module.exports = __webpack_public_path__ + "front/img/11.149a25bb.png";